/* eslint-disable eqeqeq */
/*
 * Author M. Atoar Rahman
 * Title: D3 Report DataTable
 * Description: D3 Report DataTable
 * Date: 15/03/2022
 */

import { isEmpty } from 'lodash';
import { Fragment } from 'react';
import useDataTable from '../../../hooks/useDataTable';

export default function DataTable({ medicinData, partner, dateOrMonthRange }) {
    const tableStyle = {
        paddingLeft: '5px',
        paddingRight: '5px',
        lineHeight: '33px',
    };

    console.log({ medicinData });

    function ItemTitle() {
        return <span className="ps-2">Item Name</span>;
    }

    const partnerLength = partner?.length;

    function Title() {
        return (
            <table className="table table-bordered mb-0 text-center" style={tableStyle}>
                <thead>
                    <tr>
                        <th colSpan={partnerLength * 2} className="m-0">
                            {dateOrMonthRange}
                        </th>
                    </tr>
                    <tr>
                        {partner?.map((el) => (
                            <th
                                width="300px"
                                key={Math.random() * 1000}
                                colSpan="2"
                                className="m-0"
                            >
                                {el.name}
                            </th>
                        ))}
                    </tr>
                    <tr>
                        {partner?.map(() => (
                            <Fragment key={Math.random() * 1000}>
                                <th width="150px" className="m-0">
                                    UNHCR Stock Consumption
                                </th>
                                <th width="150px" className="m-0">
                                    Monthly Consumption (Considering Non-UNHCR Stock &amp; Stock Out
                                    Days)
                                </th>
                            </Fragment>
                        ))}
                    </tr>
                </thead>
            </table>
        );
    }

    const columns = [
        {
            name: <ItemTitle />,
            cell: (row) => <span className="ps-2">{row.drug_name}</span>,
            sortable: true,
            wrap: true,
            width: '250px',
            fixed: true,
        },
        {
            name: <Title />,
            cell: (row) => (
                <table className="table table-bordered mb-0 text-center" style={tableStyle}>
                    <tbody>
                        <tr style={{ borderTopWidth: '0px' }}>
                            {partner?.map((ele) => {
                                if (isEmpty(row.partner_summary_data)) {
                                    return (
                                        <Fragment key={Math.random() * 1000}>
                                            <td width="150px">0</td>
                                            <td width="150px">0</td>
                                        </Fragment>
                                    );
                                }
                                return row?.partner_summary_data?.map((item) =>
                                    ele.id == item.partner_id ? (
                                        <Fragment key={Math.random() * 1000}>
                                            <td width="150px">{item.total_consumed}</td>
                                            <td width="150px">{item.total_non_unhcr_consumed}</td>
                                        </Fragment>
                                    ) : (
                                        <Fragment key={Math.random() * 1000}>
                                            <td width="150px">0</td>
                                            <td width="150px">0</td>
                                        </Fragment>
                                    )
                                );
                            })}
                        </tr>
                    </tbody>
                </table>
            ),
        },
    ];

    const search_column = { name: 'Name' };
    return useDataTable({
        columns,
        data: medicinData,
        search_column,
        pagination: false,
        cellPadding: '0px',
        borderWidth: '0px',
    });
}
